import React, { useState } from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <div className="text-2xl font-bold bg-gradient-to-r from-[#3E97FF] to-[#1C3C73] bg-clip-text text-transparent">
              Infinitux
            </div>
            <div className="text-2xl font-light text-[#252F4A]">Solutions</div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="text-[#252F4A] hover:text-[#3E97FF] transition-colors font-medium"
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('nosotros')}
              className="text-[#252F4A] hover:text-[#3E97FF] transition-colors font-medium"
            >
              Nosotros
            </button>
            <button 
              onClick={() => scrollToSection('servicios')}
              className="text-[#252F4A] hover:text-[#3E97FF] transition-colors font-medium"
            >
              Servicios
            </button>
            <button 
              onClick={() => scrollToSection('productos')}
              className="text-[#252F4A] hover:text-[#3E97FF] transition-colors font-medium"
            >
              Productos
            </button>
            {/* <button 
              onClick={() => scrollToSection('contacto')}
              className="text-[#252F4A] hover:text-[#3E97FF] transition-colors font-medium"
            >
              Contacto
            </button> */}
            <Button 
              onClick={() => scrollToSection('contacto')}
              className="bg-[#3E97FF] hover:bg-[#1C3C73] text-white px-6 py-2 rounded-lg transition-colors"
            >
              Contáctanos
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-[#252F4A] hover:text-[#3E97FF] transition-colors"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="text-[#252F4A] hover:text-[#3E97FF] transition-colors font-medium text-left"
              >
                Inicio
              </button>
              <button 
                onClick={() => scrollToSection('nosotros')}
                className="text-[#252F4A] hover:text-[#3E97FF] transition-colors font-medium text-left"
              >
                Nosotros
              </button>
              <button 
                onClick={() => scrollToSection('servicios')}
                className="text-[#252F4A] hover:text-[#3E97FF] transition-colors font-medium text-left"
              >
                Servicios
              </button>
              <button 
                onClick={() => scrollToSection('productos')}
                className="text-[#252F4A] hover:text-[#3E97FF] transition-colors font-medium text-left"
              >
                Productos
              </button>
              <button 
                onClick={() => scrollToSection('contacto')}
                className="text-[#252F4A] hover:text-[#3E97FF] transition-colors font-medium text-left"
              >
                Contacto
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;